import React from 'react';
import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import CustomTitleWithBlueBackground from '../../common/CustomTitleWithBlueBackground';
import InstructionsNumberedList from './InstructionsNumberedList';
import { useThemeContext } from '../../../contexts/BaseThemeContextProvider';

const instructionsTwo = [
  'Place the cartridge back in the silver sample bag making sure the desiccant card is still inside.',
  'Seal the sample bag and place it in the return mailer envelope. Seal the mailer envelope and stick the return label to the front.',
  'Return the sample to our lab by dropping it at any USPS location or mailbox. You can also drop it at some other locations including some UPS or FedEx locations.',
];

const ReturnYourSampleTestInstructions = () => {
  const { theme } = useThemeContext();
  return (
    <Box sx={{ p: 0, mt: 2 }}>
      <CustomTitleWithBlueBackground text="Return your sample" gutterBottom={false} parentSxProps={{ mb: 2 }} />
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: { md: 3 },
        }}
      >
        <Box>
          <List
            sx={{
              padding: 0,
              '& .MuiTypography-root': {
                lineHeight: 1.3,
                fontSize: '14px',
              },
            }}
          >
            <ListItem sx={{ alignItems: 'flex-start', padding: 0 }}>
              <ListItemText primary="1." sx={{ mr: 2, width: 2 }} />
              <ListItemText
                primary="Close the sampler cartridge by lifting the flaps and squeezing together until you hear it click."
                sx={{ width: '100%', ml: 1 }}
              />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', padding: 0 }}>
              <ListItemText primary="2." sx={{ mr: 2, width: 2 }} />
              <ListItemText primary="Write your details on the label provided:" sx={{ width: '100%', ml: 1 }} />
            </ListItem>

            <ListItem
              sx={{ alignItems: 'flex-start', padding: 0, flexDirection: 'column', marginLeft: { md: '20px' } }}
            >
              <ListItemText primary="a. Your full name" sx={{ ml: 1, mb: 0 }} />
              <ListItemText primary="b. Date of Birth" sx={{ ml: 1, mb: 0 }} />
              <ListItemText primary="c. Phone number" sx={{ ml: 1, mb: 0 }} />
              <ListItemText primary="d. Date and time you finished collecting your sample" sx={{ ml: 1, mb: 0 }} />
            </ListItem>

            <ListItem sx={{ alignItems: 'flex-start', padding: 0 }}>
              <ListItemText primary="3." sx={{ mr: 2, width: 2 }} />
              <ListItemText
                primary="Place the sticker over the Neoteryx label on the front of the sampler cartridge. Please avoid covering the identification barcode on the back of the cartridge."
                sx={{ width: '100%', ml: 1 }}
              />
            </ListItem>
            <Box
              component="img"
              src={'/images/how-to-collect-sample/label-your-sample.png'}
              alt="Home"
              sx={{
                alignItems: 'center',
                width: '380px',
                height: '180px',
                borderRadius: '16px',
                backgroundColor: 'white',
              }}
            />
          </List>
        </Box>
        <Box>
          <InstructionsNumberedList lists={instructionsTwo} startingIndex={3} />
          <Typography
            sx={{
              color: theme.custom.pages.howTo.takeSampleCollection.tabs.collectingSampleWarning.color,
              mt: 2,
              fontSize: '0.9em',
            }}
          >
            *Important! Please ship your sample back on the same day you collect it. Drop off your completed kit at your
            local USPS post office or post box before the last pickup to ensure it reaches our lab promptly. Our lab
            currently operates Monday-Friday. So kits sent on Friday or at the weekend will not be processed until the
            following week.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ReturnYourSampleTestInstructions;
